import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { checkAuthScope, checkSession } from './checkAuth';
import { openModal } from '../../modals/redux/modalActions';

const mapState = (state) => {
  return {
    auth: state.auth,
    authDetail: state.auth.authorities,
    expiresIn: state.auth.expiresIn,
  };
};

const actions = {
  checkAuthScope,
  checkSession,
  openModal,
};

export default function authWrap(ComposedComponent) {
  class Authenticate extends Component {
    componentDidMount = () => {
      this.checkAndRedirect();
    };

    componentDidUpdate = () => {
      this.checkAndRedirect();
    };

    checkAndRedirect = async () => {
      const {
        expiresIn,
        authDetail,
        location,
        checkAuthScope,
        checkSession,
        openModal,
        history,
      } = this.props;
      try {
        if (Date.now() < expiresIn) {
          checkAuthScope(openModal, authDetail, location.pathname);
        } else {
          checkSession(history);
        }
      } catch (err) {
        console.log(err);
      }
    };
    render() {
      return (
        <Fragment>
          <ComposedComponent {...this.props} />
        </Fragment>
      );
    }
  }

  return connect(mapState, actions)(Authenticate);
}
